// ==============================================
// FILE: frontend/src/config/api.config.js
// ==============================================

export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.www.glocybs.co.in/api/v1',
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
  HEADERS: {
    'Content-Type': 'application/json',
  },
};

export const STORAGE_KEYS = {
  ACCESS_TOKEN: process.env.REACT_APP_STORAGE_ACCESS_TOKEN || 'access_token',
  USER_DATA: process.env.REACT_APP_STORAGE_USER_DATA || 'user_data',
  IS_ADMIN_LOGGED_IN: process.env.REACT_APP_STORAGE_IS_ADMIN_LOGGED_IN || 'isAdminLoggedIn',
};

export const ROUTES = {
  LOGIN: process.env.REACT_APP_ROUTE_LOGIN || '/login',
  ADMIN_DASHBOARD: process.env.REACT_APP_ROUTE_ADMIN_DASHBOARD || '/admin/dashboard',
  SUPER_ADMIN_LOGIN: process.env.REACT_APP_ROUTE_SUPER_ADMIN_LOGIN || '/super-admin/login',
  SUPER_ADMIN_APPROVALS: process.env.REACT_APP_ROUTE_SUPER_ADMIN_APPROVALS || '/super-admin/approvals',
  FEEDBACK: process.env.REACT_APP_ROUTE_FEEDBACK || '/',
};

export const APP_INFO = {
  NAME: process.env.REACT_APP_NAME || 'Feedback System',
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
};